import { render, staticRenderFns } from "./ReportAbuse.vue?vue&type=template&id=565eb4a4&"
import script from "./ReportAbuse.vue?vue&type=script&lang=js&"
export * from "./ReportAbuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports